import { type FunctionComponent, type PropsWithChildren } from 'react';

import styles from './FormFieldHelper.module.scss';

export interface FormFieldHelperProps extends PropsWithChildren {
  'data-testid'?: string;
  /** @deprecated Use data-testid instead. */
  testId?: string;
}

export const FormFieldHelper: FunctionComponent<FormFieldHelperProps> = ({
  children,
  'data-testid': dataTestId,
  testId: oldTestId,
}) => {
  if (!children) {
    return null;
  }
  const testId = dataTestId ?? oldTestId;
  return (
    <div className={styles.helper} data-testid={testId && `${testId}-helper`}>
      {children}
    </div>
  );
};

FormFieldHelper.displayName = 'FormFieldHelper';
